<template>
  <div class="preview">
    <screen :ProjectInfo="$store.state.ProjectInfo"></screen>
  </div>
</template>

<script>
// @ is an alias to /src
import Screen from '@/views/commonviews/Screen.vue';
export default {
  name: 'Preview',
  components: { Screen },
  data() {
    return {};
  },
  created() {},

  mounted() {
    document.title = this.$store.state.ProjectInfo.Name;
    setTimeout(() => {
      this.$store.dispatch('getProject').then(() => {
        this.setRatio();
      });
    }, 1000);
    window.addEventListener('resize', this.onResize);
    this.$nextTick(() => {
      setTimeout(() => {
        this.setRatio();
      }, 100);
    });
  },
  methods: {
    onResize() {
      this.setRatio();
    },
    setRatio() {
      let { clientWidth: c_width, clientHeight: c_height } = document.body;
      let { width: p_width, height: p_height } = this.$store.state.ProjectInfo.ScreenSize;
      let w_Ratio = Math.round((c_width / p_width) * 100);
      let h_Ratio = Math.round((c_height / p_height) * 100);
      this.$store.commit('set_ScreenRatio', {
        w_Ratio,
        h_Ratio,
      });
    },
    showLoading() {},
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
    this.showLoading();
  },
};
</script>

<style lang="scss" scoped>
.preview {
  height: 100vh;
  width: 100vw;
  position: relative;
  .loading-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: $loading-mask-color;
    z-index: 999;
  }
  .screen {
    width: 100%;
    height: 100%;
  }
}
</style>
